import './index.css';

import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { matchPath } from 'react-router-dom';
import { Root } from 'components/root';
import reportWebVitals from './reportWebVitals';
import { history } from 'store/router/history';
import { dropSentryNoise } from 'utils/sentryFilters';
import {
  BUILDING_PREFIX,
  PROVIDER_PATHS,
  PROVIDER_BASE_PATH,
  ROOT_PATH,
  RECEIPT_MODAL_PATH,
  CHECKOUT_MODAL_PATH,
  REDIRECT_PATH,
  ERROR_PATH,
  DEFAULT_PATH,
} from 'shared/consts';

// Generate routes for Sentry using path constants
const generateSentryRoutes = () => {
  const paths = [
    PROVIDER_PATHS.CLASS_DETAILS,
    PROVIDER_PATHS.EVENT_TIME_SLOTS_DETAILS,
    PROVIDER_PATHS.EVENT_TIME_SLOTS,
    PROVIDER_PATHS.EVENT_DETAILS,
    PROVIDER_PATHS.GYM_CARD,
    PROVIDER_PATHS.SERVICE_TYPE,
    PROVIDER_PATHS.AVAILABILITY,
    PROVIDER_PATHS.SCHEDULE,
    PROVIDER_BASE_PATH,
    RECEIPT_MODAL_PATH,
    CHECKOUT_MODAL_PATH,
    ROOT_PATH,
  ];

  // Generate both building-prefixed and non-prefixed versions
  const routePaths = paths.flatMap(path => [`${BUILDING_PREFIX}${path}`, path]);

  // Add standalone paths
  routePaths.push(REDIRECT_PATH, ERROR_PATH, DEFAULT_PATH);

  return routePaths.map(path => ({ path }));
};

const routes = generateSentryRoutes();

const isLocalDevelopment =
  process.env.NODE_ENV === 'development' ||
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

if (!isLocalDevelopment) {
  Sentry.init({
    dsn: 'https://42281b711375490396a9d13913b65d02@o379338.ingest.sentry.io/5868423',
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
        routes,
        matchPath,
      }),
      Sentry.extraErrorDataIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    beforeSend: dropSentryNoise,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
